import { StackTypes, VStack } from '@genial/components';
import React from 'react';

interface TableContentItemColumnProps extends StackTypes.Props {
  children: React.ReactNode;
}

export const TableContentItemColumn: React.FC<TableContentItemColumnProps> = ({
  children,
  ...rest
}) => {
  const flexValue = rest.flex ?? 1;

  return (
    <VStack {...rest} flex={flexValue}>
      {children}
    </VStack>
  );
};
